import { render, staticRenderFns } from "./AxFilesystemNodeLink.vue?vue&type=template&id=651b1738&scoped=true&"
import script from "./AxFilesystemNodeLink.vue?vue&type=script&lang=ts&"
export * from "./AxFilesystemNodeLink.vue?vue&type=script&lang=ts&"
import style0 from "./AxFilesystemNodeLink.vue?vue&type=style&index=0&id=651b1738&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651b1738",
  null
  
)

export default component.exports